// extracted by mini-css-extract-plugin
export default {"main":"mba-z"};